<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-input v-model="form.typeEvidenceCategoryId" hidden/>

        <t-input v-model="form.name" :add-error="error.name" label="Categoria de Evolução"
                 small="Utilizado quando inserida alguma imagem para demonstração da evolução da obra." required/>

        <t-input v-model="form.otherCodeLabel" label="Código de Integração"
                 small="Utilizado quando há algum código especial de outro sistema para esta categoria" />

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'TypeEvidenceCategoryForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "typeEvidenceCategoryId",
      form: {
        typeEvidenceCategoryId: 0,
        typeEvidenceCategoryNumber: 0,
        name: "",
        otherCodeLabel: "",
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

